import React from "react"
import {Image} from "@fluentui/react-northstar"
import celebrationImage from "../Icons/celebration.svg"
import {ImageContainer, Title} from "./styled"
import getUrl from "helpers/images/getUrl"

const Header = () => (
    <>
        <ImageContainer>
            <Image src={getUrl(celebrationImage)} />
        </ImageContainer>
        <Title>Welcome to Perkbox Celebrations!</Title>
    </>
)

export default Header
